module.exports = __webpack_public_path__ + "static/img/qq.ab91240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qq.png
// module id = mTCC
// module chunks = 0